<div class="toolbar d-flex align-items-center justify-content-end flex-wrap">
    <div class="toolbar-icon-btn" (click)="createNewItem()">
        <fa-icon [icon]="iconsService.faIconsSolid.faPlus"></fa-icon>
    </div>
    <div class="toolbar-icon-btn" (click)="createNewEmoji()">
        <fa-icon [icon]="iconsService.faIconsSolid.faFaceSmileWink"></fa-icon>
    </div>
    <div class="toolbar-icon-btn" (click)="goHome()">
        <fa-icon [icon]="iconsService.faIconsSolid.faHouseChimney"></fa-icon>
    </div>
    <div class="toolbar-icon-btn" (click)="openChats()">
        <fa-icon [icon]="iconsService.faIconsSolid.faPersonFalling"></fa-icon>
        <span *ngIf="unreadMessageCount > 0" class="position-absolute top-0 translate-middle badge rounded-pill bg-danger">
            {{unreadMessageCount}}
            <span class="visually-hidden">unread messages</span>
        </span>
    </div>
    <span class="mx-3">BINST</span>
    <img class="logo" src="/assets/binst-icon.png" alt="logo">
</div>
